import { render, staticRenderFns } from "./NoticesExtraData.vue?vue&type=template&id=36b72541&"
import script from "./NoticesExtraData.vue?vue&type=script&lang=js&"
export * from "./NoticesExtraData.vue?vue&type=script&lang=js&"
import style0 from "./NoticesExtraData.vue?vue&type=style&index=0&id=36b72541&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports